
import React from 'react';
import PropTypes from 'prop-types';
import BackgroundWrapper from 'common/designer-modules/modules/background-wrapper';
import JoinButton from 'common/designer-modules/modules/join-button';
import Link from 'common/components/modules/link';

import IconLabel from 'common/components/elements/icon-label';
import { useSiteGlobalSettingsHelper } from 'common/designer-modules/globalSettingsHelper';


const AboutMe = ({
   isMobile,
   globalSettings,
   isNextApp,
}) => {
   const { getModifySectionGlobalSetting,  getSiteSocialMediaLinks } = useSiteGlobalSettingsHelper(globalSettings);
   const settings = getModifySectionGlobalSetting('about_me');
   const socialMediaLinks = getSiteSocialMediaLinks();

   return (
      <BackgroundWrapper
         settings={ settings }
         isMobile={ isMobile }
      >
         {
            settings.join_button?.enabled && (
               <JoinButton
                  settings={ settings.join_button }
               />
            )
         }
         {
            settings?.social_media_link_enable && Boolean(socialMediaLinks?.length) && (
               <div className='flex gap-6'>
                  <span className='text-major dark:text-major-dark tetx-base leading-[20px] font-semibold'>FOLLOW ME</span>
                  <div className='flex gap-4'>
                     {
                        socialMediaLinks && socialMediaLinks.map((mediaLink) => {
                           const logo = mediaLink.logo;
                           return (
                              <Link isNextApp={ isNextApp } href={ mediaLink.link } target='_blank' rel='noopener noreferrer'>
                                 {
                                    !!logo ?
                                       <img src={ logo } alt='' className='group-hover:hidden w-5 h-5 rounded-full object-contain object-center' />
                                       :
                                       <IconLabel
                                          name='link'
                                          size='base'
                                          color='secondary'
                                          wrrapperBgColor='group-hover:!hidden bg-transparent border border-divider'
                                          className='!w-5 min-w-[20px] !h-5'
                                       />
                                 }
                              </Link>
                           )
                        })
                     }

                  </div>
               </div>
            )
         }
      </BackgroundWrapper>
   )
}

AboutMe.propTypes = {
   globalSettings: PropTypes.object,
   isMobile: PropTypes.bool,
   isNextApp: PropTypes.bool,
};

export default AboutMe;


